import React from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import { SERVER_URL } from "../util/ServerUtil";
import { useEffect } from "react";

/* Protect a route from unauthenticated users. Check for Firebase auth state */

import { ReactNode } from "react";

interface FirebaseRouteProps {
  children: ReactNode;
}

export const FirebaseRoute: React.FC<FirebaseRouteProps> = ({ children }) => {
  const { isLoggedIn } = useAppContext();

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};
